module.exports = __webpack_public_path__ + "img/pthy@2x.0e4b7f8f.png";